import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../shares/Navbar";
import Footer from "../shares/Footer";
import FollowupForm from "./FollowupForm";
import { useParams } from "react-router-dom";

// Others File

const Followup = () => {
  const { type } = useParams();
  return (
    <>
      <div className="hp-section-one">
        <Navbar />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">
          پیگیری{" "}
          {type == "com-damage"
            ? "  اعتراض به پرونده خسارت"
            : type == "con-damage"
            ? "درخواست مشاوره خسارت"
            : "درخواست مشاوره پزشکی"}
        </p>

        <FollowupForm />
      </div>
      <Footer />
    </>
  );
};
export default Followup;
